import React, {CSSProperties, forwardRef, memo, useEffect, useRef, useState} from "react";
import './PropertyGroup.css'
import {batchUpdateProperties, batchUpdateTags, getAllCardList, getNoteList, tagsByGroupId} from "../../../model";
import {
    arrayMove,
    horizontalListSortingStrategy,
    SortableContext,
    useSortable,
} from '@dnd-kit/sortable';
import {DndContext, DragEndEvent} from "@dnd-kit/core";
import {Dropdown, Flex, Popover, Tag} from "antd";
import {getImagePath, getImagePathWithTheme, getImagePathWithThemeSvg, getItem, isDarkMode} from "@/utils";
import {
    IconAddToFavor,
    IconAddToFavorWithTheme,
    IconDelete,
    IconDeleteRed, IconDeleteWhite,
    IconEdit,
    IconMenuExportPcanvas, IconRelatedCardType,
    IconRemoveFavor
} from "@/Icon";
import {t} from "i18next";
import {
    DEFAULT_DARK_TAG_BACKGROUND_COLOR,
    DEFAULT_TAG_BACKGROUND_COLOR,
    MAP_GROUP_BACKGROUND_COLOR,
    MAP_GROUP_BACKGROUND_ICON,
    MAX_Z_INDEX
} from "@/Const";
import {getFavorChildrenMenu} from "@/Utility";
import global from "@/global";
import {useAtom} from "jotai";

let mIsDragged = false;
const PropertyGroup = forwardRef((props:{group:any,searchKey?:any,onEditGroup:any,onAddTag:any,onDeleteGroup:any,onTagAction:any}, ref) => {
    const [items,setItems] = useState([]);
    useEffect(()=>{
        if (props.group){
            searchProperty();
        }
    },[props.searchKey]);

    useEffect(() => {
        if (props.group){
            //排序
            const arrayTags = props.group.children;
            arrayTags.sort((a,b)=>{
                if (a.createTime && b.createTime){
                    return a.createTime - b.createTime;
                }
                return 0;
            })
            arrayTags.sort((a,b)=>{
                if (a.propertySort != undefined && b.propertySort != undefined){
                    return a.propertySort - b.propertySort;
                }
                return 0;
            })

            setItems(arrayTags);
        }
    }, [props.group]);


    //组的操作菜单......
    const getArrayGroupMore:any = (tag:any)=>{
        return [
            getItem(t("Edit"), 'edit', <IconEdit/>, undefined, undefined, () => {
                props.onEditGroup(props.group);
            }),
            // getItem(tag?.isFavirated == 1?t('Cancel favor'):t("Add to Favorites"), 'favor', tag?.isFavirated == 1?<IconRemoveFavor/>:<IconAddToFavor/>, undefined, undefined, () => {
            //     props.onTagAction('favor',tag);
            // }),
            getItem(<span className={isDarkMode()?'':'delete-color'}>{t("Delete")}</span>, 'delete',
                <IconDeleteRed/>, undefined, undefined, () => {
                    props.onDeleteGroup(props.group);
                }),
        ]
    }


    /**
     * 搜索标签....
     */
    const searchProperty = async ()=>{
        let szSearchKey = '';
        if (props.searchKey){
            szSearchKey = props.searchKey?.toLowerCase();
        }
        let arrayTags = props.group.children;
        if (szSearchKey){
            if (props.group.name.toLowerCase().includes(szSearchKey)){

            }else{
                arrayTags = arrayTags.filter(p=>p.name.toLowerCase().includes(szSearchKey));
            }
        }
        arrayTags.sort((a,b)=>{
            if (a.createTime && b.createTime){
                return a.createTime - b.createTime;
            }
            return 0;
        })
        arrayTags.sort((a,b)=>{
            if (a.propertySort != undefined && b.propertySort != undefined){
                return a.propertySort - b.propertySort;
            }
            return 0;
        })

        setItems(arrayTags);
    }

    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        if (!over) {
            return;
        }
        if (active.id !== over.id) {
            let arrayNew = [...items];

            const oldIndex = arrayNew.findIndex((item) => item.id === active.id);
            const newIndex = arrayNew.findIndex((item) => item.id === over.id);
            arrayNew = arrayMove(arrayNew, oldIndex, newIndex);
            setItems(arrayNew);

            for (let i=0;i<arrayNew.length;i++){
                arrayNew[i].propertySort = i;
            }
            batchUpdateProperties(arrayNew);

            // setItems((data) => {
            //     const oldIndex = data.findIndex((item) => item.id === active.id);
            //     const newIndex = data.findIndex((item) => item.id === over.id);
            //     return arrayMove(data, oldIndex, newIndex);
            // });
        }
    };

    const handleDragMove = (event)=>{
        mIsDragged = true;
    }

    const getStyle = ()=>{
        const style:CSSProperties = {};
        if (props.searchKey){
            if (items.length > 0){
                style.display = 'flex';
            }else{
                style.display = 'none';
            }
        }else{
            style.display = 'flex';
        }
        return style;
    }

    return(
        items.length == 0?<></>:
        <div className={'property-groupitem flex-col'} style={getStyle()}>
            <div className={'flex-row-vertical-center'}>
                <span className={'property-groupitem-title'}>{props.group?.name}</span>
                {/*<div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>*/}
                {/*    <img className={'img-14 cursor-pointer'} src={getImagePathWithTheme('tag_group_add')} onClick={()=>{*/}
                {/*        props.onAddTag(props.group);*/}
                {/*    }}/>*/}
                {/*    {*/}
                {/*        props.group.id != -1 &&*/}
                {/*        <Dropdown menu={{items:getArrayGroupMore()}} overlayStyle={{minWidth:'200px'}}>*/}
                {/*            <img className={'img-14 ml-12 cursor-pointer'} src={getImagePathWithTheme('tag_h_more')}/>*/}
                {/*        </Dropdown>*/}
                {/*    }*/}
                {/*</div>*/}
            </div>

            <div className={'mt-16'}>
                <DndContext onDragEnd={handleDragEnd} onDragMove={handleDragMove}>
                    <SortableContext items={items} strategy={horizontalListSortingStrategy}>
                        <Flex gap="16px 2px" wrap={"wrap"}>
                            {
                                items.map(p=>{
                                    return(
                                        <DraggableTag tag={p} key={p.id} onTagAction={props.onTagAction}/>
                                    )
                                })
                            }
                        </Flex>
                    </SortableContext>
                </DndContext>
            </div>

        </div>
    )
});


/*****************************---tag---***************************************/
const commonStyle: React.CSSProperties = {
    cursor: 'pointer',
    transition: 'unset', // Prevent element from shaking after drag
};
const DraggableTag: React.FC<any> = memo((props) => {
    const {onTagAction} = props;
    const { listeners, transform, transition, isDragging, setNodeRef } = useSortable({ id: props.tag.id });
    const [isHover,setIsHover] = useState(false);
    const [isMoreMenuOpened,setIsMoreMenuOpened] = useState(false);
    const [isShowContextMenu,setIsShowContextMenu] = useState(false);
    const [arrayGroupMoreMenu,setArrayGroupMoreMenu] = useState<any>([]);
    const [tag,setTag] = useState(props.tag);


    useEffect(() => {
        setTag(props.tag);
    }, [props.tag]);

    useEffect(() => {
        setArrayGroupMoreMenu(arrayGroupMore(true));
    }, []);

    const arrayGroupMore = (isDefaultProperty)=>{
        const arrayMenus = [];
        arrayMenus.push( getItem(t("Edit property"), 'edit', <IconEdit/>, undefined, undefined, () => {
            onTagAction('edit',tag);
        }))
        if (!isDefaultProperty){
            arrayMenus.push(getItem(t("RelatedCardType"), 'relatedLibrary', <IconRelatedCardType/>, undefined, undefined, () => {
                onTagAction('relatedLibrary',tag)
            }));
        }

        arrayMenus.push(getItem(t("Delete property"), 'delete', <IconDelete/>, undefined, undefined, () => {
            onTagAction('delete',tag);
        }));
        return arrayMenus;
    }

    const style = transform
        ? {
            ...commonStyle,
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
            transition: isDragging ? 'unset' : transition, // Improve performance/visual effect when dragging
        }
        : commonStyle;
    style.height = '36px';
    style.lineHeight = '36px';
    style.padding = '0 12px';
    style.borderRadius = '8px';
    style.border = 'none';
    style.background = (tag.backgroundColor || DEFAULT_TAG_BACKGROUND_COLOR);
    if (isDarkMode()){
        if (style.background == DEFAULT_TAG_BACKGROUND_COLOR){
            style.background = DEFAULT_DARK_TAG_BACKGROUND_COLOR;
        }
    }

    /**
     * 标签文本颜色
     */
    const getTextColor = ()=>{
        let szTextColor = MAP_GROUP_BACKGROUND_COLOR[tag?.backgroundColor] || '#000000';
        if (szTextColor == '#000000' && isDarkMode()){
            szTextColor = '#FFFFFF';
        }
        if (tag.isSelected){
            szTextColor = '#FFFFFF';
        }
        return szTextColor;
    }

    const getIconName = ()=>{
        let szIconName = MAP_GROUP_BACKGROUND_ICON[tag?.backgroundColor] || 'tag_more_gray';
        if (szIconName == "tag_more_gray" && isDarkMode()){
            szIconName = "tag_more_gray_white";
        }
        return szIconName;
    }

    const patchMenuFavor = ()=>{
        let opacity = '1.0';
        if (isDefaultProperty()){
            opacity = '0.4';
        }
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-item');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];

                item.style.opacity = opacity;
            }
        },100)
    }

    const isDefaultProperty = ()=>{
        return props.tag?.groupName == 'default';
    }


    return (
        <Dropdown trigger={['contextMenu']} open={isShowContextMenu} menu={{items:arrayGroupMoreMenu}} onOpenChange={(e) => {
            setIsShowContextMenu(e);
            const isDefault = isDefaultProperty()
            const arrayNewMenu:any = [...arrayGroupMore(isDefault)];
            if (isDefault) {
                for (let i=0;i<arrayNewMenu.length;i++) {
                    arrayNewMenu[i].disabled = true;
                }
            }
            setArrayGroupMoreMenu(arrayNewMenu);
            patchMenuFavor();
        }} overlayStyle={{minWidth:'200px'}}>
            <Tag style={style} ref={setNodeRef} {...listeners} onMouseUp={(event:any)=>{
                if (mIsDragged) {
                    mIsDragged = false;
                    return;
                }
                if (event.button == 0) {
                    const newTag = {...tag};
                    if (!newTag.isSelected) {
                        newTag.isSelected = true;
                    }else {
                        newTag.isSelected = false;
                    }
                    setTag(newTag);
                    onTagAction('click', newTag);
                }
            }} onMouseEnter={()=>{
                setIsHover(true);
            }} onMouseLeave={()=>{
                setIsHover(false);
                // setIsMoreMenuOpened(false);
            }}>
                <Popover
                    trigger={['click']}
                    arrow={false}
                    placement={"bottom"}
                    open={isMoreMenuOpened}
                    onOpenChange={(e) => {
                        setIsMoreMenuOpened(e);
                    }}
                    content={
                        arrayGroupMoreMenu.map(p => {
                            return (
                                <>
                                    {
                                        p.children?.length > 0 ?
                                            //二级
                                            <Popover zIndex={MAX_Z_INDEX}
                                                     overlayInnerStyle={{margin: '0', padding: '4px'}}
                                                     align={{offset: [4, 0]}} arrow={false} trigger={['hover']}
                                                     placement={'rightTop'}
                                                     content={
                                                         p.children.map(pp => {
                                                             return (
                                                                 <div
                                                                     className={'flex-row-vertical-center cursor-pointer dropdown-item'}
                                                                     style={{
                                                                         padding: '12px 8px',
                                                                         height: '30px',
                                                                         margin: '0px'
                                                                     }} onMouseDown={(e) => {
                                                                     e.stopPropagation();
                                                                     onTagAction('favor', {...tag, key: pp.key});

                                                                     setTimeout(() => {
                                                                         setIsMoreMenuOpened(false);
                                                                     }, 100)

                                                                 }} onMouseUp={(e) => {
                                                                     e.stopPropagation();
                                                                 }}>
                                                                     <img className={'img-14'}
                                                                          src={getImagePathWithTheme('favor_folder.svg')}/>
                                                                     <span
                                                                         className={'ml-6 default-font-size'}>{pp.label}</span>
                                                                 </div>
                                                             )
                                                         })
                                                     }>
                                                <div key={p.key} style={{
                                                    height: '32px',
                                                    padding: '0 12px',
                                                    margin: '0 4px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px'
                                                }}
                                                     className={'flex-row-vertical-center cursor-pointer dropdown-item'}
                                                     onMouseUp={(e) => {
                                                         e.stopPropagation();
                                                         onTagAction('favor', {...tag});

                                                         setTimeout(() => {
                                                             setIsMoreMenuOpened(false);
                                                         }, 100)
                                                     }}>
                                                    {p.icon}
                                                    {
                                                        p.key == 'delete' ? p.label :
                                                            <span style={{display: 'block', width: '100%'}}
                                                                  className={`${p.key == 'delete' ? 'delete-color' : ''} default-font-size`}>{p.label}</span>
                                                    }
                                                    <img className={'img-8'} style={{marginLeft: 'auto'}}
                                                         src={getImagePathWithTheme('right_arrow')}/>
                                                </div>
                                            </Popover> :
                                            <div key={p.key} style={{
                                                height: '32px',
                                                padding: '0 12px',
                                                margin: '0 4px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                opacity: isDefaultProperty() ? '0.4' : '1'
                                            }}
                                                 className={`flex-row-vertical-center ${isDefaultProperty() ? 'cursor-disabled' : 'cursor-pointer'} ${isDefaultProperty() ? '' : 'dropdown-item'}`}
                                                 onMouseUp={(event) => {
                                                     event.stopPropagation();
                                                     setIsMoreMenuOpened(false);
                                                     if (isDefaultProperty()) return;
                                                     onTagAction(p.key, tag);
                                                 }}>
                                                {p.icon}
                                                {
                                                    <span style={{display: 'block', width: '100%',}}
                                                          className={`default-font-size`}>{p.label}</span>
                                                }
                                            </div>

                                    }
                                </>
                            )
                        })
                    }
                    overlayInnerStyle={{margin: '0px', padding: '4px 0px'}}
                    overlayStyle={{minWidth: '200px', margin: '0px', padding: '0px'}}>

                    <div className={'flex-center'} style={{minWidth: '140px'}} onMouseUp={(event)=>{
                        if (event.button == 0) {
                            event.stopPropagation();
                            event.preventDefault();
                            const arrayNewMenu: any = [...arrayGroupMore(isDefaultProperty())];
                            setArrayGroupMoreMenu(arrayNewMenu);
                            setIsMoreMenuOpened(!isMoreMenuOpened);
                        }
                    }}>
                        <img className={'img-14'} style={{marginLeft: '20px'}}
                             src={getImagePathWithThemeSvg(tag.icon)}/>
                        <span className={'font-family-medium ml-8'}
                              style={{color: 'var(--text-color)', marginRight: '20px',paddingTop:'1px'}}>{tag.groupName == 'default'?t(tag.name):tag.name}</span>
                        <div className={'flex-center'} style={{width: '30px', position: 'absolute', right: '6px'}}>
                            {
                                isHover ?
                                    <div className={'flex-center'} style={{width: '26px', height: '26px'}}
                                         onMouseUp={(event) => {
                                             // if (event.button == 0) {
                                             //     event.stopPropagation();
                                             //     event.preventDefault();
                                             //     const arrayNewMenu: any = [...arrayGroupMore(isDefaultProperty())];
                                             //     setArrayGroupMoreMenu(arrayNewMenu);
                                             //     setIsMoreMenuOpened(!isMoreMenuOpened);
                                             // }
                                         }}>
                                        <img className={'img-14 ml-6'}
                                             src={getImagePath(getIconName())}
                                        />
                                    </div> : <div className={'flex-center font-family-medium'}
                                                  style={{color: 'var(--text-color)'}}>{tag.arrayRelatedType?.length || ''}</div>

                            }
                        </div>
                    </div>
                </Popover>

            </Tag>
        </Dropdown>

    );
});

export default memo(PropertyGroup);























